// extracted by mini-css-extract-plugin
export var entityChip = "_s9-0";
export var entityChipMissing = "_s9-1";